export const isTokenExpired = (tokenExpiry) => {
  const now = Date.now();
  return now > tokenExpiry;
};

export const refreshAccessToken = async () => {

  try {
    const refreshToken = localStorage.getItem("refreshToken");
    const refreshTokenExpiry = localStorage.getItem("refreshTokenExpiry");

    // Validate the refresh token before attempting
    if (!refreshToken || isTokenExpired(refreshTokenExpiry)) {
      console.error("Refresh token is expired or null.");
      logoutUser();
      return null; // Return null so the caller knows the refresh failed
    }

    // Fetch new tokens
    const response = await fetch(
      "https://auth.zenithdn.com/realms/quarkus/protocol/openid-connect/token",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: new URLSearchParams({
          grant_type: "refresh_token",
          client_id: "backend-service",
          refresh_token: refreshToken,
        }),
      }
    );

    if (!response.ok) {
      throw new Error("Failed to refresh token");
    }

    const data = await response.json();

    // Save new tokens
    saveTokens(data);

    console.log("Token refreshed successfully!");
    return data.access_token; // Return the new access token
  } catch (error) {
    console.error("Failed to refresh access token:", error);
    logoutUser(); // Log out the user
    return null; // Return null in case of error
  }
};


  
export const getAccessToken = async () => {
  const accessToken = localStorage.getItem("accessToken");
  const accessTokenExpiry = localStorage.getItem("accessTokenExpiry");
  console.log("isToken Expired ", isTokenExpired(accessTokenExpiry), " for ", accessToken)
  if (isTokenExpired(accessTokenExpiry) && accessToken!=null) {
    console.log("wttttttttttttfn")

    console.log("Access token expired, refreshing...");
    return await refreshAccessToken(); // Refresh and return new token
  }

  console.log("access Token", accessToken)
  return accessToken; // Return valid token
};


export const logoutUser = () => {
  localStorage.removeItem("accessToken");
  localStorage.removeItem("refreshToken");
  localStorage.removeItem("accessTokenExpiry");
  localStorage.removeItem("refreshTokenExpiry");
  localStorage.removeItem("user");
};